module.exports = __webpack_public_path__ + "img/in.62038177.svg";